module.exports = __webpack_public_path__ + "media/images/help/header_03-21185af64b10891fb3195ca4c2226673.png";